import { createPrinterAdapter } from '@/features/print/adapters/printer-adapter-factory'
import { AnyConnectionOptions } from '@/features/print/types'
import { Buffer } from 'buffer'

export async function printData(
    base64String: string,
    connectionOptions: AnyConnectionOptions
): Promise<void> {
    const buffer = Buffer.from(base64String, 'base64')
    const adapter = createPrinterAdapter(connectionOptions)
    await adapter.print(buffer)
}
